export function isIpadLike(): boolean {
  if (navigator.platform === 'iPad') return true;
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) return true;
  // iPadOS 13+ Safari reports MacIntel; touch points distinguish it.
  if (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.userAgent)) {
    return true;
  }
  return false;
}
